import React from 'react';

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, error };
	}

	componentDidCatch(error, info) {
		console.error('Admin ErrorBoundary:', error, info);
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className="min-h-screen bg-black text-white flex items-center justify-center p-6">
					<div className="max-w-md text-center">
						<h2 className="text-xl font-bold mb-2">Something went wrong.</h2>
						<p className="text-gray-400 mb-4">{this.state.error?.message || 'An unexpected error occurred.'}</p>
						<button
							onClick={() => {
								this.setState({ hasError: false, error: null });
								window.location.reload();
							}}
							className="bg-cyan-600 hover:bg-cyan-700 text-white px-4 py-2 rounded-md"
						>
							Reload
						</button>
					</div>
				</div>
			);
		}
		return this.props.children;
	}
}

export default ErrorBoundary; 